module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-3 py-3 w-100"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 bg-lightest"
  }, [(_vm.isLoadingHistoric) ? _c('div', {
    staticClass: "p-4 text-center mb-4 w-100"
  }, [_c('loader')], 1) : (_vm.tableRows.length == 0) ? _c('div', {
    staticClass: "text-center dark p-4 my-2 w-100"
  }, [_c('span', {}, [_vm._v("This task has no historic.")])]) : _c('div', [_c('div', {
    staticClass: "d-flex justify-content-end my-2 w-100"
  }, [(_vm.currentPagination.numPages > 1) ? _c('uib-pagination', {
    attrs: {
      "total-items": _vm.paginationSettings.totalItems,
      "items-per-page": _vm.paginationSettings.itemsPerPage,
      "boundary-link-numbers": false,
      "max-size": 7
    },
    on: {
      "change": _vm.fetchTaskHistoric
    },
    model: {
      value: (_vm.currentPagination),
      callback: function($$v) {
        _vm.currentPagination = $$v
      },
      expression: "currentPagination"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('list', {
    attrs: {
      "header": _vm.header,
      "body": _vm.body,
      "rows": _vm.tableRows,
      "actions": _vm.actions,
      "showNoDataMessage": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end my-2"
  }, [(_vm.currentPagination.numPages > 1) ? _c('uib-pagination', {
    attrs: {
      "total-items": _vm.paginationSettings.totalItems,
      "items-per-page": _vm.paginationSettings.itemsPerPage,
      "boundary-link-numbers": false,
      "max-size": 7
    },
    on: {
      "change": _vm.fetchTaskHistoric
    },
    model: {
      value: (_vm.currentPagination),
      callback: function($$v) {
        _vm.currentPagination = $$v
      },
      expression: "currentPagination"
    }
  }) : _vm._e()], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('h1', [_vm._v("Task history")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4000aedf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4000aedf"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/scheduleTasks/components/taskHistoric.vue
// module id = 3069
// module chunks = 0